import { BNBIcon } from "shared/src/icons/crypto/BNBIcon";
import { BCHIcon } from "shared/src/icons/crypto/BCHIcon";
import { BitcoinIcon } from "shared/src/icons/crypto/BitcoinIcon";
import { DAIIcon } from "shared/src/icons/crypto/DAIIcon";
import { EURCIcon } from "shared/src/icons/crypto/EURCIcon";
import { EtheriumIcon } from "shared/src/icons/crypto/EtheriumIcon";
import { FiatFlag } from "shared/src/FiatFlag";
import { FDUSDIcon } from "shared/src/icons/crypto/FDUSDIcon";
import { getCountryCode } from "shared/src/getCountryCode";
import { LINKIcon } from "shared/src/icons/crypto/LINKIcon";
import { PYUSDIcon } from "shared/src/icons/crypto/PYUSDIcon";
import { SHIBIcon } from "shared/src/icons/crypto/SHIBIcon";
import { SOLIcon } from "shared/src/icons/crypto/SOLIcon";
import { USDCIcon } from "shared/src/icons/crypto/USDCIcon";
import { USDTIcon } from "shared/src/icons/crypto/USDTIcon";
import { WLDIcon } from "shared/src/icons/crypto/WLDIcon";
import { RadixQuestionMarkIcon } from "shared/src/icons/RadixQuestionMarkIcon";

type Props = {
  cryptoCode: string;
  className?: string;
};

export const CryptoFlag = ({ cryptoCode, className }: Props) => {
  const normalizedCryptoCode = cryptoCode?.toLowerCase();
  const fiatCountryCode = getCountryCode(cryptoCode?.toUpperCase() ?? null);

  switch (normalizedCryptoCode) {
    case "eth":
      return <EtheriumIcon className={className} />;
    case "btc":
      return <BitcoinIcon className={className} />;
    case "bch":
      return <BCHIcon className={className} />;
    case "sol":
      return <SOLIcon className={className} />;
    case "usdc":
      return <USDCIcon className={className} />;
    case "usdt":
      return <USDTIcon className={className} />;
    case "fdusd":
      return <FDUSDIcon className={className} />;
    case "pyusd":
      return <PYUSDIcon className={className} />;
    case "wld":
      return <WLDIcon className={className} />;
    case "dai":
      return <DAIIcon className={className} />;
    case "shib":
      return <SHIBIcon className={className} />;
    case "link":
      return <LINKIcon className={className} />;
    case "eurc":
      return <EURCIcon className={className} />;
    case "bnb":
      return <BNBIcon className={className} />;
    default:
      if (fiatCountryCode !== "XX") {
        return (
          <FiatFlag
            currencyCode={cryptoCode}
            style={{ width: "1.5em", height: "1.5em" }}
            svg
          />
        );
      }

      return <RadixQuestionMarkIcon className={className} />;
  }
};
